import React, { useState } from "react";
import { LogOut, Settings as SettingsIcon, CircleUser } from "lucide-react";
import { MENU_ITEMS, resolveVisibleMenus } from "../config/menuConfig";
import { isLoginHSProduct } from "../config/product";

// ──────────────────────────────────────────────
// MobileTabBar — loginHS 모바일 전용 하단 탭바 (앱 스타일)
// 좌측 세로 레일 대신 화면 하단 가로 탭으로 메뉴 전환.
// 데스크톱/DocuAI 도메인에선 렌더되지 않음 (App.js isMobileShell 분기).
// ──────────────────────────────────────────────

const MobileTabBar = ({
  activeTab,
  setActiveTab,
  menuVisibility,
  isManager,
  userGroup,
  userId,
  onLogout,
  onOpenAccountSettings,
}) => {
  const [accountOpen, setAccountOpen] = useState(false);

  // 모바일 = 본연 기능 + 속견표(HS 탐색) + 문의 (결정트리·분류사례 등은 분류 화면 근거자료로 접근)
  const MOBILE_TAB_IDS = [
    "hs-ai-classify",
    "hs-unified-search",
    "inquiry-board",
  ];
  let items = resolveVisibleMenus(MENU_ITEMS, menuVisibility, isManager);
  if (isLoginHSProduct()) {
    items = items.filter((m) => m.category === "hs");
  }
  items = items.filter((m) => MOBILE_TAB_IDS.includes(m.id));

  const navigate = (item) => {
    setAccountOpen(false);
    if (item.href) {
      if (item.spa) {
        window.history.pushState({}, "", item.href);
        window.dispatchEvent(new PopStateEvent("popstate"));
      } else {
        window.location.href = item.href;
      }
    } else {
      if (new URLSearchParams(window.location.search).get("audit")) {
        window.history.pushState({}, "", "/");
        window.dispatchEvent(new PopStateEvent("popstate"));
      }
      setActiveTab(item.id);
    }
  };

  return (
    <>
      {/* 계정 시트 (탭바 위로 떠오르는 미니 메뉴) */}
      {accountOpen && (
        <>
          <div
            onClick={() => setAccountOpen(false)}
            style={{ position: "fixed", inset: 0, zIndex: 58 }}
          />
          <div
            style={{
              position: "fixed",
              right: 8,
              bottom: "calc(64px + env(safe-area-inset-bottom))",
              zIndex: 59,
              background: "var(--audit-bg-elevated, #fff)",
              border: "1px solid var(--audit-border, #e5e7eb)",
              borderRadius: 12,
              boxShadow: "0 8px 28px rgba(0,0,0,0.16)",
              minWidth: 200,
              overflow: "hidden",
            }}
          >
            <div
              style={{
                padding: "12px 14px",
                borderBottom: "1px solid var(--audit-border, #e5e7eb)",
              }}
            >
              <div style={{ fontSize: 13, fontWeight: 700 }}>{userGroup}</div>
              <div style={{ fontSize: 11.5, color: "#9ca3af" }}>{userId}</div>
            </div>
            {onOpenAccountSettings && (
              <button
                onClick={() => {
                  setAccountOpen(false);
                  onOpenAccountSettings();
                }}
                style={sheetBtnStyle}
              >
                <SettingsIcon size={15} /> 내 계정 설정
              </button>
            )}
            <button
              onClick={onLogout}
              style={{ ...sheetBtnStyle, color: "#dc2626" }}
            >
              <LogOut size={15} /> 로그아웃
            </button>
          </div>
        </>
      )}

      {/* 하단 탭바 */}
      <nav
        style={{
          position: "fixed",
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 57,
          display: "flex",
          alignItems: "stretch",
          background: "var(--audit-bg, #fff)",
          borderTop: "1px solid var(--audit-border, #e5e7eb)",
          paddingBottom: "env(safe-area-inset-bottom)",
          overflowX: "auto",
        }}
      >
        {items.map((item) => {
          const Icon = item.icon;
          const isActive = activeTab === item.id;
          return (
            <button
              key={item.id}
              onClick={() => navigate(item)}
              style={{
                flex: 1,
                minWidth: 64,
                border: "none",
                background: "transparent",
                padding: "8px 2px 7px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 3,
                cursor: "pointer",
                color: isActive ? "var(--audit-accent, #1a73e8)" : "#6b7280",
              }}
            >
              <Icon size={20} strokeWidth={isActive ? 2.2 : 1.6} />
              <span
                style={{
                  fontSize: 10,
                  fontWeight: isActive ? 700 : 500,
                  whiteSpace: "nowrap",
                  maxWidth: 76,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {item.shortLabel || item.label}
              </span>
            </button>
          );
        })}
        {/* 계정 탭 */}
        <button
          onClick={() => setAccountOpen((v) => !v)}
          style={{
            flex: 1,
            minWidth: 64,
            border: "none",
            background: "transparent",
            padding: "8px 2px 7px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 3,
            cursor: "pointer",
            color: accountOpen ? "var(--audit-accent, #1a73e8)" : "#6b7280",
          }}
        >
          <CircleUser size={20} strokeWidth={accountOpen ? 2.2 : 1.6} />
          <span style={{ fontSize: 10, fontWeight: accountOpen ? 700 : 500 }}>
            계정
          </span>
        </button>
      </nav>
    </>
  );
};

const sheetBtnStyle = {
  width: "100%",
  display: "flex",
  alignItems: "center",
  gap: 8,
  padding: "11px 14px",
  border: "none",
  background: "transparent",
  fontSize: 13.5,
  color: "#374151",
  cursor: "pointer",
};

export default MobileTabBar;
